import axios from 'axios';
import { AssetPortfolio, UpdateAssetPortfolioRequest } from '../type/AssetPortfolio.type';
import { LOCALFORAGE_YN, SERVER_URL } from '../../../common/comstant/CommonConstants';
import { useAssetPortfolioStore } from '../store/AssetPortfolio.store';

export const useAssetPortfolioAPI = () => {
  const {
    insertAssetPortfolioToStore,
    getAssetPortfolioListFromStore,
    updateAssetPortfolioAtStore,
    deleteAssetPortfolioAtStore,
  } = useAssetPortfolioStore();

  const insertAssetPortfolio = async (assetPortfolio: AssetPortfolio) => {
    if (LOCALFORAGE_YN) {
      return insertAssetPortfolioToStore(assetPortfolio);
    } else {
      return axios.post<string>(`${SERVER_URL}/asset-portfolio`, assetPortfolio);
    }
  };

  const getAssetPortfolioList = async () => {
    if (LOCALFORAGE_YN) {
      return getAssetPortfolioListFromStore();
    } else {
      return axios.get<AssetPortfolio[]>(`${SERVER_URL}/asset-portfolio`);
    }
  };

  const updateAssetPortfolio = async (id: string, updateAssetPortfolioRequest: UpdateAssetPortfolioRequest) => {
    if (LOCALFORAGE_YN) {
      return updateAssetPortfolioAtStore(id, updateAssetPortfolioRequest);
    } else {
      return axios.put<string>(`${SERVER_URL}/asset-portfolio/${id}`, updateAssetPortfolioRequest);
    }
  };

  const deleteAssetPortfolio = async (id: string) => {
    if (LOCALFORAGE_YN) {
      return deleteAssetPortfolioAtStore(id);
    } else {
      return axios.delete<string>(`${SERVER_URL}/asset-portfolio/${id}`);
    }
  };

  return {
    insertAssetPortfolio,
    getAssetPortfolioList,
    updateAssetPortfolio,
    deleteAssetPortfolio,
  };
};
